export const SWIPE_PANEL = 84; // px per action panel
export const SWIPE_INTENT = 10; // px before committing to an axis

export type SwipeIntent = 'none' | 'horizontal' | 'vertical';
/** Commit once; vertical takes priority when both thresholds are reached together. */
export function swipeIntent(prev: SwipeIntent, dx: number, dy: number): SwipeIntent {
  if (prev !== 'none') return prev;
  if (Math.abs(dy) >= SWIPE_INTENT) return 'vertical';
  return Math.abs(dx) >= SWIPE_INTENT ? 'horizontal' : 'none';
}

export interface SwipeGeometry { rowWidth: number; hasRight: boolean; leftCount: number /* 0-3 */ }
const panelWidth = (count: number) => Math.max(0, Math.min(3, Math.trunc(count))) * SWIPE_PANEL;

/** Translate from the resting offset, clamped to the available action geometry. */
export function swipeOffset(dx: number, openOffset: number, geo: SwipeGeometry): number {
  const offset = dx + openOffset;
  if (offset >= 0) return geo.hasRight ? Math.min(offset, Math.max(0, geo.rowWidth)) : 0;
  const width = panelWidth(geo.leftCount);
  return width ? Math.max(offset, -width) : 0;
}

export type SwipeRelease = { kind: 'fire-right' } | { kind: 'open-left'; offset: number } | { kind: 'close' };
/** Fire past half the row; reveal left panels past half of one panel. */
export function swipeRelease(offset: number, geo: SwipeGeometry): SwipeRelease {
  if (geo.hasRight && offset > Math.max(0, geo.rowWidth) / 2) return { kind: 'fire-right' };
  const width = panelWidth(geo.leftCount);
  if (width && offset < -SWIPE_PANEL / 2) return { kind: 'open-left', offset: -width };
  return { kind: 'close' };
}
